/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SafetyNetStartAttestationRequest} from '@cash-web/protos/squareup/client/flipper/flipper.pb'
import {SafetyNetStartAttestationResponse} from '@cash-web/protos/squareup/client/flipper/flipper.pb'


export const safetyNetStartAttestation = (request:SafetyNetStartAttestationRequest, options?: CashRequestOptions) => post<SafetyNetStartAttestationRequest, SafetyNetStartAttestationResponse>("/2.0/cash/safety-net-start-attestation", request, {...options, rejectOnError: true })